// extracted by mini-css-extract-plugin
export default {"container":"WeddingParty_container__4-5am","list":"WeddingParty_list__XsKnS","bestPeople":"WeddingParty_bestPeople__A4p96","bestPerson":"WeddingParty_bestPerson__p0kF3"};